import "./Feedback.css";

export default function FeedbackBox({
  defaultFeedback = "",
  defaultMarks = 0,
  defaultStatus = "",
  maxMarks = 100,
  readOnly = false,
}) {
  const getStatusClass = () => {
    if (defaultStatus === "correct") return "status-correct";
    if (defaultStatus === "incorrect") return "status-incorrect";
    return "status-unattempted";
  };

  const getStatusLabel = () => {
    if (defaultStatus === "correct") return "Correct";
    if (defaultStatus === "incorrect") return "Incorrect";
    return "Unattempted";
  };

  return (
    <div className={`feedback-box feedback-box--view ${getStatusClass()}`}>
      
      <h5>Question Feedback</h5>
      {/* Top Status + Marks */}
      <div className="feedback-box__summary">
        <div className="feedback-box__status-pill">
          {getStatusLabel()}
        </div>

        <div className="feedback-box__marks-display">
          {defaultMarks} / {maxMarks}
        </div>
      </div>

      {/* Divider */}
      <div className="feedback-box__divider" />

      {/* Feedback */}
      <div className="feedback-box__content">
        {defaultFeedback ? (
          <p>{defaultFeedback}</p>
        ) : (
          <p className="feedback-box__empty">No feedback provided</p>
        )}
      </div>
    </div>
  );
}